const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaCnhCategoria: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'RACAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'RACAO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'RACAO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.nome,
                    id_transportadora: item.id_transportadora
                }))
            };

        case 'RACAO_CNH_CATEGORIA_LISTADO':
                 
			return { ...state, listaCnhCategoria: action.payload.data };

        default:
            return state;
    }
}
